<!--
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description:
-->
<template>
  <div class="container-main-body">
    <img class="dashboard-esco" src="../assets/images/ESCO.png" />
    <div class="quick-menu-container">
      <div class="menu-item menu1" @click="handleSetMenus('0')"><span>台纸管理</span></div>
      <div class="menu-item menu2" @click="handleSetMenus('167284420397633536')"><span>板块管理</span></div>
      <div class="menu-item menu3" @click="handleSetMenus('189683591620464640')"><span>成品管理</span></div>
      <div class="menu-item menu4" @click="handleSetMenus('469952446073016320')"><span>外库管理</span></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Dashboard',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      datetimeStr: ''
    }
  },
  methods: {
    handleSetMenus: function (menuId) {
      this.parent.handleSetMenus(menuId)
    }
  }
}
</script>
<style scoped>
  .dashboard-esco {
    display: block;
    margin: 100px auto;
  }
  .quick-menu-container {
    display: flex;
    margin: 0 auto;
    width: 1104px;
  }
  .quick-menu-container > div.menu-item {
    position: relative;
    flex: 1;
    height: 321px;
    text-align: center;
    font-size: 24px;
    cursor: pointer;
  }
  .quick-menu-container > div.menu-item > span {
    display: block;
    position: absolute;
    bottom: 50px;
    width: 100%;
    color: #fff;
  }
  .menu1 {
    background: url('../assets/images/paper_manage.png') no-repeat center center;
  }
  .menu2 {
    background: url('../assets/images/board_manage.png') no-repeat center center;
  }
  .quick-menu-container > div.menu-item.menu2 > span {
    bottom: 120px;
  }
  .menu3 {
    background: url('../assets/images/product_manage.png') no-repeat center center;
  }
  .menu4 {
    background: url('../assets/images/external_manage.png') no-repeat center center;
  }
  .quick-menu-container > div.menu-item.menu4 > span {
    bottom: 120px;
  }
</style>
